module.exports = __webpack_public_path__ + "assets/home.1182db63.svg";